export enum UserMsgType {
  U2WS_LiveboardCodeCheck = 'U2WS_LiveboardCodeCheck', // users sending a code to link their current machine w/ a liveboard socket
  U2WS_LiveboardQuery = 'U2WS_LiveboardQuery', // users asking which liveboard socket(s) are linked to their machine (if any)
  U2WS_LiveboardRevoke = 'U2WS_LiveboardRevoke', // users revoking the link between their machine and a liveboard socket
  U2WS_LiveboardPreAuth = 'U2WS_LiveboardPreAuth', // users fetching token for a liveboard, skipping the code check step
}
